import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SolicitudService } from '@services/solicitud.service';
import { ExpedienteListItem } from '@models/evaluacion-medica.interface';
import { AlertService } from '@services/alert.service';
import ExpedienteEstados from '@shared/enums/expediente-estados.enum';
import { CierreAdministrativoService } from '@services/cierre-administrativo.service';
import { SessionService } from '@services/session.service';

@Component({
  selector: 'app-dictamen-listado',
  templateUrl: './dictamen-listado.component.html',
  styleUrls: ['./dictamen-listado.component.scss']
})
export class DictamenListadoComponent implements OnInit {
  public casos: ExpedienteListItem[] = [];
  public isLoading = false;
  
  // Filtros
  public filtroRutFuncionario = '';
  public filtroFechaDesde = '';
  public filtroFechaHasta = '';



  constructor(
    private router: Router,
    private solicitudService: SolicitudService,
    private alertService: AlertService,
    private cierreAdminService: CierreAdministrativoService,
    private sessionService: SessionService
  ) {}

  get isEvaluado(): boolean {
    return this.sessionService.isFuncionarioEvaluado();
  }

  ngOnInit(): void {
    this.cargarCasos();
  }

  async cargarCasos() {
    this.isLoading = true;
    try {
      const filtros: any = {};
      if (this.filtroRutFuncionario) {
        filtros.rut_fun = this.filtroRutFuncionario;
      }
      if (this.filtroFechaDesde) {
        filtros.exp_fecha_ingreso_desde = this.filtroFechaDesde;
      }
      if (this.filtroFechaHasta) {
        filtros.exp_fecha_ingreso_hasta = this.filtroFechaHasta;
      }

      const response: any = await this.solicitudService.listarSolicitudesFiltradas(filtros);
      if (response && response.data) {
        this.casos = response.data;
      }
    } catch (error) {
      console.error('Error al cargar casos', error);
      this.alertService.error('Error al cargar el listado de casos');
    } finally {
      this.isLoading = false;
    }
  }

  goToRegistrar(caso: ExpedienteListItem): void {
    if (this.canRegisterDictamen(caso.eex_codigo)) {
        this.router.navigate(['/administracion/dictamen-medico', caso.exp_id]);
    }
  }

  async onEmitirResolucion(caso: ExpedienteListItem) {
    this.isLoading = true;
    this.alertService.showLoading('Emitiendo resolución...');
    try {
      const response: any = await this.solicitudService.emitirResolucion({ exp_id: caso.exp_id });
      this.alertService.close();

      if (response?.data?.pdf_url) {
        window.open(response.data.pdf_url, '_blank');
      }
      
      this.alertService.success('Resolución emitida exitosamente.');
      await this.cargarCasos();
    } catch (error: any) {
      this.alertService.close();
      if (error?.status === 409) {
        this.alertService.error('Ya existe una resolución para este expediente.');
      } else {
        this.alertService.error('Error al emitir la resolución. Por favor intente nuevamente.');
      }
    } finally {
      this.isLoading = false;
    }
  }

  onFiltrar(): void {
    this.cargarCasos();
  }

  onLimpiar(): void {
    this.filtroRutFuncionario = '';
    this.filtroFechaDesde = '';
    this.filtroFechaHasta = '';
    this.cargarCasos();
  }

  getButtonText(estadoCodigo: number): string {
    switch (estadoCodigo) {
      case ExpedienteEstados.pendiente_evaluacion_medica:
        return 'Registrar Evaluación Médica';
      case ExpedienteEstados.en_comision_medica:
        return 'Registrar Comisión Médica';
      case ExpedienteEstados.resolucion_emitida:
        return 'Emitir Resolución';
      default:
        return 'Registrar Evaluación Médica';
    }
  }

  canRegisterDictamen(estadoCodigo: number): boolean {
    if (this.isEvaluado) return estadoCodigo === ExpedienteEstados.resolucion_emitida; // Allow seeing resolution if read-only maybe? Wait, button says 'Ver Resolución'. So allow it if it's resolution emitted.
    return [
        ExpedienteEstados.pendiente_evaluacion_medica,
        ExpedienteEstados.en_comision_medica,
        ExpedienteEstados.en_apelacion,
        ExpedienteEstados.resolucion_emitida
    ].includes(estadoCodigo);
  }

  canCierreAdministrativo(estadoCodigo: number): boolean {
      if (this.isEvaluado) return false;
      return estadoCodigo !== ExpedienteEstados.cierre_administrativo && 
             estadoCodigo !== ExpedienteEstados.resolucion_emitida;
  }
  onCierreAdministrativo(caso: ExpedienteListItem): void {
    this.router.navigate(['/administracion/cierre-administrativo', caso.exp_id]);
  }
}
